<template>
  <div class="input-wrapper" :class="{isError: error}">
    <label v-if="label" class="label">
      {{label}}
      {{required ? ' *' : ''}}
    </label>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: [String, Boolean],
      required: false,
      default: false
    },
    required: {
      type: [Boolean],
      required: false,
      default: false
    },
    error: {
      type: [String, Boolean],
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.input-wrapper {
  width: 100%;
  margin-bottom: 20px;
  //font-family: $secondary-font-family;

  & /deep/ label {
    font-family: $secondary-font-family;
    letter-spacing: 1px;
    // font-size: 0.875rem;
    //font-weight: bold;
  }

  & /deep/ .vue-tel-input {
    position: relative;
    .vti__input {
      padding-left: 50px;
    }
    .vti__dropdown {
      padding-top: 14px;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }
  }

  & /deep/ .vti__dropdown {
    // border-bottom: 2px solid $border-color;
    margin-right: 0 !important;

  }


  & /deep/ input,
  & /deep/ textarea {
    background-color: transparent;
    color: $body-color;
    font-size: 1rem;
    box-sizing: border-box;
    position: relative;
    width: 100%;
    //font-size: 1rem;
    min-height: 18px;
    border: 0;
    width: calc(100% - 2px);
    padding: 10px 0 15px 0;
    border-bottom: 2px solid $border-color;
    border-radius: 0;
    // box-shadow: -6px 8px 0px -7px $primary-btn-bg, 7px 8px 0px -7px $primary-btn-bg;
    -webkit-transition: box-shadow 0.3s;
    transition: box-shadow 0.3s;
    &:focus{
      outline: none;
      border-color: $active-color;
      //box-shadow: 0 1px 0 0 #495057;
      // box-shadow: -6px 9px 0px -7px $primary-btn-bg, 7px 9px 0px -7px $primary-btn-bg //this one
    }
    &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: $gray-4;
      -webkit-text-fill-color: $gray-4;
      opacity: 1; /* Firefox */
    }

    &:-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: $gray-4;
    }

    &::-ms-input-placeholder { /* Microsoft Edge */
      color: $gray-4;
    }

    &::-webkit-datetime-edit-fields-wrapper {
      padding: 0;
    }

    &::-webkit-calendar-picker-indicator {
      display: none;
    }

    -webkit-box-shadow: inset 0 0 0 50px $body-bg;
    -webkit-text-fill-color: $body-color;


  }

  & /deep/ select {
    background-color: transparent;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    width: 100%;
    font-size: 1rem;
    color: #1F2429;
    //min-height: 18px;
    border: 0;
    border-bottom: 2px solid $border-color;
    border-radius: 0;
    padding: 10px 0 15px 0;
    // width: calc(100% - 2px);

    // box-shadow: -3px 8px 0px -7px #1F2429, 0px 8px 0px -7px #1F2429;
    transition: box-shadow 0.3s;
    appearance: none;
    //height: 40px;
    &:focus{
      outline: none;
      border-color: $active-color;
      //box-shadow: 0 1px 0 0 #495057;
      // box-shadow: -6px 9px 0px -7px $primary-btn-bg, 7px 9px 0px -7px $primary-btn-bg //this one
    }
  }



  &.isError /deep/ input,
  &.isError /deep/ .vti__dropdown,
  &.isError /deep/ select {
    color: $error;
    border-color: $error;
    &:focus {
      box-shadow: 0 1px 0 0 $error;
    }
  }


  & /deep/ .error {
    color: $error;
    font-size: 0.7em;
  }
}
</style>
